import React, { useState } from "react";
import { useTranslation } from "/utils/hooks/useCustomTranslation";

import Input from "/components/core/labels/Input";

import { CopyToClipboard } from "react-copy-to-clipboard";
import CustomButton from "/components/core/ButtonDefault";
import { useDepositAddress } from "/api/cashier/direct-deposit/deposit-address";
import { useAxiosWithAuth } from "/utils/hooks/useAxiosAPI";

let sto = null;

const Title = ({ id }) => {
  const { t } = useTranslation();
  return (
    <p className="df gap-6">
      <span>0{id}</span> {t(`wallet.buySection.exchange.steps.${id}`)}
    </p>
  );
};

export default function Exchange({ back, cryptoExs }) {
  const { t } = useTranslation();
  const [copy, setCopy] = useState(false);

  const onCopy = () => {
    sto && clearTimeout(sto);
    setCopy(true);
    sto = setTimeout(() => setCopy(false), 1500);
  };

  const axiosClient = useAxiosWithAuth();
  const { data } = useDepositAddress(axiosClient, "1");

  return (
    <>
      <p className="fixel_22 text-center">
        {t("wallet.buySection.exchange.instructions")}
      </p>
      <div className="list-rows df fd-c fixel_16_sbl">
        <Title id={1} />
        <div className="df icons">
          {cryptoExs.map((ex) => (
            <a key={ex.icon} href={ex.link} target="_blank" rel="noopener noreferrer">
              <img src={ex.icon} alt="Exchange" />
            </a>
          ))}
        </div>
        <Title id={2} />
        <Title id={3} />
        <Title id={4} />
        <Title id={5} />
        <Title id={6} />

        <div className="wallet-ddress df aic-">
          <Input readOnly={true} value={data?.address} name="walletAddress" />
          <CopyToClipboard text={data?.address} onCopy={onCopy}>
            <div
              className={"icon_copy icon-24 ar-1" + (copy ? " copyed" : "")}
            ></div>
          </CopyToClipboard>
        </div>

        {/* <div className="qr as-c df cover ar-1">
          <img src={wallet_qr} alt={t("wallet.buySection.exchange.qrCode")} />
        </div> */}

        <Title id={7} />

        <CustomButton
          onClick={back}
          classname={`go-back grey as-c`}
          def={40}
          title={t("labels.back")}
        />
      </div>
    </>
  );
}
